import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { IotModel } from "../models/iot.model";
import { Model } from "../models";
import { Result } from "../commands/types";

@Injectable({
	providedIn: "root",
})
export class AnnouncementsModel extends Model {
	private readonly iotModel = inject(IotModel);

	// @ts-expect-error TS7006
	performAction(action): Observable<Result> {
		return this.performAsyncAction(action);
	}

	newAnnouncementsIotEvent() {
		return this.iotModel.subscribe("intocare-announcements/new");
	}
}
